import { compose, withProps } from 'recompose';
import { withRouter } from 'react-router';
import MarketingLeads from '../components/MarketingLeads';

const MarketingLeadsContainer = compose(
  withRouter,
  withProps(props => ({
    baseUrl: props.location.pathname,
  })),
);

export default MarketingLeadsContainer(MarketingLeads);
